import { useFilterDate } from "@/common/hooks/useFilterDate";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { formatDate, formatDateRange } from "@/common/utils/formatters";
import { ClientCompanyBranchesEquipmentsConsumptionsTotalizerData } from "@/features/privateCompanies/types/clientCompanyBranchesEquipmentsConsumptionsTotalizer.type";
import BranchesEquipmentsConsumptionsTotalizerTable from "./table/BranchesEquipmentsConsumptionsTotalizerTable";

interface BranchesEquipmentsConsumptionsTotalizerPrintProps {
  data: ClientCompanyBranchesEquipmentsConsumptionsTotalizerData | undefined;
}

const BranchesEquipmentsConsumptionsTotalizerPrint = ({
  data,
}: BranchesEquipmentsConsumptionsTotalizerPrintProps) => {
  const {
    filterParams,
  } = useFilterParams();

  const { date } = useFilterDate(filterParams);

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex flex-col">
        <div className="flex items-center justify-between gap-8">
          <p className="text-lg font-bold">
            Totalizadores de consumo de equipamentos por filial
          </p>

          <img
            src="/tcard-logo.png"
            className="h-5"
          />
        </div>

        {date && (
          <div>
            <p className="italic text-sm font-light">
              {date.from && date.to
                ? formatDateRange(new Date(date.from), new Date(date.to))
                : date.from
                  ? formatDate(new Date(date.from))
                  : date.to && formatDate(new Date(date.to))}
            </p>
          </div>
        )}
      </div>

      <BranchesEquipmentsConsumptionsTotalizerTable
        print
        data={data}
      />
    </div>
  );
}

export default BranchesEquipmentsConsumptionsTotalizerPrint;
